import '../App.css';
import {List, ListItem, Box, Button,  Typography} from '@mui/material/';
import TextInput from '../components/TextInput';
import SingleSelect from '../components/SingleSelect';
import Dropdown from '../components/Dropdown';
import MultiDropdown from '../components/MultiDropdown';
import MultiSelect from '../components/MultiSelect';
import { Navigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';import mentors from './../json/top3mentors';
import languages from './../json/languages'
import sports from './../json/sports'
import universities from './../json/universities'
import axios from "axios";
import Scale from '../components/Scale';
import * as constants from './../constants'
import MenuAppBar from "../components/MenuAppBar";

function MenteeForm() {
    const universityYearOptions = ["Freshman", "Sophomore", "Junior", "Senior", "5th Year", "Graduate Student"]
    const [error, setError] = useState('')
    const [isOtherUniversity, setIsOtherUniversity] = useState(false)
    const [isNoUniversity, setIsNoUniversity] = useState(false)
    const [isAlumni, setIsAlumni] = useState(false)
    const [isOtherUniversityAlumni, setIsOtherUniversityAlumni] = useState(false)

    const validationSchema = Yup.object().shape({
        //q1: Yup.string().required('(This question is required)'),
        q1: Yup.array().of(
            Yup.string()
        ).required('(This question is required)').test('check-min-slots',  '(Only select one if you want to select "Prefer not to say")',
            function(value) {
                let valid = true
                if (value.length > 1 && value.includes("Prefer not to say")) {
                    valid = false
                }
                return valid
            })
            .min(1, '(Please select at least one option)')
            .max(5, '(Please select at least one option)'),
        q2: Yup.string().required('(This question is required)'),
        q3: Yup.string().required('(This question is required)')
            .test('university',  '(This question is required)',
            function(value) {
                setIsOtherUniversity(false)
                setIsNoUniversity(false)
                if (value === undefined || value === "" || value === null) return false
                if (value === "Other") setIsOtherUniversity(true)
                if (value === "Not currently in school or Alumni") setIsNoUniversity(true)
                return true
            }),
        q3_1: Yup.string().test('universityName',  '(This question is required)',
            function(value) {
                if (isOtherUniversity) {
                    if (value === undefined || value === "" || value === null) return false
                    return true
                } else {
                    return true
                }
            }),
        q4: Yup.string().test('universityYear', '(This question is required)',
            function(value) {
                if (isNoUniversity) {
                    return true
                } else {
                    if (universityYearOptions.includes(value)) {
                        return true
                    } else {
                        return false
                    }
                }
            }),
        // q4_0: Yup.string().test('alumni', '(This question is required)',
        //     function(value) {
        //         if (isNoUniversity) {
        //             setIsAlumni(false)
        //             if (!isNoUniversity) {
        //                 return false
        //             } else {
        //                 if (value === "Yes") {
        //                     setIsAlumni(true)
        //                     return true
        //                 } else if (value === "No") {
        //                     return true
        //                 } else {
        //                     return false
        //                 }
        //             }
        //         } else {
        //             return true
        //         }
        //     }),
        // q4_1: Yup.string().test('university',  '(This question is required)',
        //         function(value) {
        //             if (isNoUniversity && isAlumni) {
        //                 setIsOtherUniversityAlumni(false)
        //                 if (value === undefined || value === "" || value === null) return false
        //                 if (value === "Other") setIsOtherUniversityAlumni(true)
        //                 return true
        //             } else {
        //                 return true
        //             }
        //         }),
        // q4_2: Yup.string().test('universityName',  '(This question is required)',
        //     function(value) {
        //         if (isNoUniversity && isAlumni && isOtherUniversityAlumni) {
        //             if (value === undefined || value === "" || value === null) return false
        //             return true
        //         } else {
        //             return true
        //         }
        //     }),
        q5: Yup.array().of(
            Yup.object().shape({
                code: Yup.string(),
                name: Yup.string(),
                nativeName: Yup.string()
          })).required('This question is required')
            .min(0, '()'),
        q6: Yup.number().min(1, '(This question is required)').max(10).required('(This question is required)'),
        q7: Yup.number().min(1, '(This question is required)').max(10).required('(This question is required)'),
        q8: Yup.number().min(1, '(This question is required)').max(10).required('(This question is required)'),
        q9: Yup.number().min(1, '(This question is required)').max(10).required('(This question is required)'),
        q10: Yup.number().min(1, '(This question is required)').max(10).required('(This question is required)'),
        q11: Yup.number().min(1, '(This question is required)').max(10).required('(This question is required)'),
        q12: Yup.number().min(1, '(This question is required)').max(10).required('(This question is required)'),
        q13: Yup.number().min(1, '(This question is required)').max(10).required('(This question is required)'),
        q14: Yup.array().of(
            Yup.string().required()
            ).required('(This question is required)')
            .min(2, '(Please select two options)')
            .max(2, '(Please select two options)'),
        q15: Yup.array().of(
            Yup.string()
        ).required('(This question is required)').test('check-min-slots',  '(Only select one if you want to select "None of the above, Only sports for me")',
            function(value) {
                let valid = true
                if (value.length > 1 && value.includes("None of the above, Only sports for me")) {
                    valid = false
                }
                return valid
            })
            .min(1, '(Please select at least one option)')
            .max(3, '(Please select at least one option)'),
        q16: Yup.number().min(1, '(This question is required)').max(10).required('(This question is required)'),
        q17: Yup.string().required('(This question is required)'),
        q18: Yup.string().required('(This question is required)'),
        q19: Yup.array().of(
            Yup.object().shape({
                name: Yup.string(),
            })).required('This question is required')
            .min(1, '(Please select at least one sport)'),
        q20: Yup.string().oneOf(['Yes', 'No'], '(This question is required)' ).required('(This question is required)'),
        q21: Yup.string().oneOf(['Yes', 'No'], '(This question is required)' ).required('(This question is required)'),
        q22: Yup.string(),
        q23: Yup.string(),
        q24: Yup.string(),
        q25: Yup.string(),
        q26: Yup.string().oneOf(['I accept'], '(If you would like to decline, please send an email to tracey@athleda.org)' ).required('(This question is required)'),

    });
    
    const { control, handleSubmit, formState: { errors }, setValue} = useForm({ resolver: yupResolver(validationSchema), shouldFocusError: true, mode:'all'});

    const getTopMentors = (data) => {
        window.scrollTo(0, 0)
        axios.post(constants.serverURL + "submitMenteeSurvey", {data},
            {
                withCredentials: true
            }).then(response => {
                window.location.href = constants.websiteURL + '#/topMentors'
            }).catch((error) => {
                if (error.request.responseText === 'expired token') {
                    window.location.href = constants.websiteURL + '#/refreshToken?redirect=menteeform'
                } else {
                    setError(error.request.responseText)
                }
            })
    }

    const onError = (data) => {
        setError('One or more of the required questions have not been answered')
        window.scrollTo(0, 0)
    }


    return(
        <div>
            <MenuAppBar title="Mentee Survey" signedIn={true}></MenuAppBar>
            <form className='screen'>
                <Box className="box">
                <List>
                    {
                        error &&
                        <ListItem sx={{ p:2, my:1.5}} className='question-block'>
                            <Typography className="font-16 error-message">{error}</Typography>
                        </ListItem>
                    }
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <MultiSelect
                            name={"q1"}
                            control={control}
                            question={"1. How do you identify yourself? It will help us make better connections for you."}
                            options = {[
                                "I identify as African",
                                "I identify as American Indian or Alaska Native",
                                "I identify as Asian",
                                "I identify as Black or African American",
                                "I identify as European",
                                "I identify as Hispanic or Latino",
                                "I identify as Native Hawaiian or Other Pacific Islander",
                                "I identify as White",
                                "I identify as some other race",
                                "Prefer not to say"
                            ]}
                            max={5}
                            required={true}
                            errors={errors.q1}
                        />
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <SingleSelect
                            name={"q2"}
                            control={control}
                            question={"2. How do you identify?"}
                            options = {[
                                "Male (including transgender men)",
                                "Female (including transgender women)",
                                "Non-binary",
                                "Gender-fluid",
                                "Agender",
                                "Other",
                                "Prefer not to say"
                            ]}
                            required={true}
                            errors={errors.q2}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <Dropdown
                            name={"q3"}
                            control={control}
                            question={"3. Which university do you currently attend?"}
                            options={universities}
                            label={"Select an option"}
                            required={true}
                            errors={errors.q3}/>
                    </ListItem>
                    {
                        isOtherUniversity && !isNoUniversity &&
                        <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                            <TextInput
                                name={"q3_1"}
                                control={control}
                                question={"3.1. What is the name of your university?"}
                                required={true}
                                errors={errors.q3_1}/>
                        </ListItem>
                    }
                    {
                        !isNoUniversity &&
                        <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                            <Dropdown
                            name={"q4"}
                            control={control}
                            question={"4. Which year are you in school?"}
                            options={universityYearOptions}
                            label={"Select an option"}
                            required={true}
                            errors={errors.q4}/>
                        </ListItem>
                    }
                    {/*{*/}
                    {/*    isNoUniversity &&*/}
                    {/*    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>*/}
                    {/*        <SingleSelect*/}
                    {/*            name={"q4_0"}*/}
                    {/*            control={control}*/}
                    {/*            question={"4. Did you graduate from a university?"}*/}
                    {/*            options = {["Yes", "No"]}*/}
                    {/*            required={true}*/}
                    {/*            errors={errors.q4_0}/>*/}
                    {/*    </ListItem>*/}
                    {/*}*/}
                    {/*{*/}
                    {/*    isNoUniversity && isAlumni &&*/}
                    {/*    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>*/}
                    {/*        <Dropdown*/}
                    {/*            name={"q4_1"}*/}
                    {/*            control={control}*/}
                    {/*            question={"4.1. Which university did you attend?"}*/}
                    {/*            options={universities.slice(0, -1)}*/}
                    {/*            label={"Select an option"}*/}
                    {/*            required={true}*/}
                    {/*            errors={errors.q4_1}/>*/}
                    {/*    </ListItem>*/}
                    {/*}*/}
                    {/*{*/}
                    {/*    isNoUniversity && isAlumni && isOtherUniversityAlumni &&*/}
                    {/*    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>*/}
                    {/*        <TextInput*/}
                    {/*            name={"q4_2"}*/}
                    {/*            control={control}*/}
                    {/*            question={"4.2. What is the name of your university?"}*/}
                    {/*            required={true}*/}
                    {/*            errors={errors.q4_2}/>*/}
                    {/*    </ListItem>*/}
                    {/*}*/}
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <MultiDropdown
                        name={"q5"}
                        control={control}
                        question={"5. Other than English, which languages are you fluent in?"}
                        options={languages}
                        label={"Select language(s)"}
                        required={false}
                        errors={errors.q5}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <Scale
                            name={"q6"}
                            control={control}
                            question={"6. How important is having a mentor who has the same racial/ethnic identity as you?"}
                            helper={["Please select a number between 1-10, where 1 is Not Important and 10 is Extremely Important."]}
                            options = {[...Array(11).keys()].slice(1)}
                            required={true}
                            errors={errors.q6}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <Scale
                            name={"q7"}
                            control={control}
                            question={"7. How important is having a mentor who identifies as the same gender as you?"}
                            helper={["Please select a number between 1-10, where 1 is Not Important and 10 is Extremely Important."]}
                            options = {[...Array(11).keys()].slice(1)}
                            required={true}
                            errors={errors.q7}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <Scale
                            name={"q8"}
                            control={control}
                            question={"8. How important is having a mentor who has expertise in their field?"}
                            helper={["Please select a number between 1-10, where 1 is Not Important and 10 is Extremely Important."]}
                            options = {[...Array(11).keys()].slice(1)}
                            required={true}
                            errors={errors.q8}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <Scale
                            name={"q9"}
                            control={control}
                            question={"9. How important is having a mentor who can hold you accountable for your growth?"}
                            helper={["Please select a number between 1-10, where 1 is Not Important and 10 is Extremely Important."]}
                            options = {[...Array(11).keys()].slice(1)}
                            required={true}
                            errors={errors.q9}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <Scale
                            name={"q10"}
                            control={control}
                            question={"10. How important is having a mentor who can help you build your brand?"}
                            helper={["Please select a number between 1-10, where 1 is Not Important and 10 is Extremely Important."]}
                            options = {[...Array(11).keys()].slice(1)}
                            required={true}
                            errors={errors.q10}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <Scale
                            name={"q11"}
                            control={control}
                            question={"11. How important is having a mentor who can support your social/mental health?"}
                            helper={["Please select a number between 1-10, where 1 is Not Important and 10 is Extremely Important."]}
                            options = {[...Array(11).keys()].slice(1)}
                            required={true}
                            errors={errors.q11}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <Scale
                            name={"q12"}
                            control={control}
                            question={"12. How important is having a mentor who can help you understand more about STEM opportunities?"}
                            helper={["Please select a number between 1-10, where 1 is Not Important and 10 is Extremely Important."]}
                            options = {[...Array(11).keys()].slice(1)}
                            required={true}
                            errors={errors.q12}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <Scale
                            name={"q13"}
                            control={control}
                            question={"13. How important is having a mentor who can help you expand your network?"}
                            helper={["Please select a number between 1-10, where 1 is Not Important and 10 is Extremely Important."]}
                            options = {[...Array(11).keys()].slice(1)}
                            required={true}
                            errors={errors.q13}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <MultiSelect
                            name={"q14"}
                            control={control}
                            question={"14. What are the top 2 areas listed below that need support with?"}
                            options = {[ "Building my brand/Elevator pitch/Networking",
                            "LinkedIn/Resume/Internships",
                            "Priorities in my day/Time management",
                            "Understanding my strengths/grit/drive"]}
                            required={true}
                            max={2}
                            errors={errors.q14}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <MultiSelect
                            name={"q15"}
                            control={control}
                            question={"15. Beyond sports, I'd like to learn more about:"}
                            helper={["(Pick up to 3)"]}
                            options = {[ "Digital health", "Medicine",
                            "Healthcare", "Technology", "Analytics",
                            "Tech Sales", "Engineering", "Financial Services",
                            "FinTech Startups", "Small Business", "Entrepreneur",
                            "None of the above, Only sports for me"]}
                            required={true}
                            max={3}
                            errors={errors.q15}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <Scale
                            name={"q16"}
                            control={control}
                            question={"16. How important is building your brand?"}
                            helper={["Please select a number between 1-10, where 1 is Not Important and 10 is Extremely Important."]}
                            options = {[...Array(11).keys()].slice(1)}
                            required={true}
                            errors={errors.q16}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <SingleSelect
                            name={"q17"}
                            control={control}
                            question={"17. Who has been the biggest influencer in a your journey as a collegiate athlete so far?"}
                            options = {[ "My academic advisor (on staff)",
                            "My athletic director/staff",
                            "My career services counselor (career services on campus)",
                            "My coach(es)",
                            "My family (mom, dad, aunt, sister, etc)",
                            "My friend(s) (boyfriend, girlfriend, teammates)",
                            "My mental health advisor",
                            "My mentor (unrelated to me)",
                            "My professor",
                            "None (no one)"
                            ]}
                            required={true}
                            errors={errors.q17}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <SingleSelect
                            name={"q18"}
                            control={control}
                            question={"18. Who has provided the most support for you holistically?(mind, body, soul, spirit)"}
                            options = {[ "My academic advisor (on staff)",
                            "My athletic director/staff",
                            "My career services counselor (career services on campus)",
                            "My coach(es)",
                            "My family (mom, dad, aunt, sister, etc)",
                            "My friend(s) (boyfriend, girlfriend, teammates)",
                            "My mental health advisor",
                            "My mentor (unrelated to me)",
                            "My professor",
                            "None (no one)"
                            ]}
                            required={true}
                            errors={errors.q18}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <MultiDropdown
                            name={"q19"}
                            control={control}
                            question={"19. What sports do you play?"}
                            options={sports}
                            label={"Select sports"}
                            required={true}
                            errors={errors.q19}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <SingleSelect
                            name={"q20"}
                            control={control}
                            question={"20. Are you in a leadership role on your campus?"}
                            helper={["Examples: team captain, class president"]}
                            options = {["Yes", "No"]}
                            required={true}
                            errors={errors.q20}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <SingleSelect
                            name={"q21"}
                            control={control}
                            question={"21. Are you a member of Student Athlete Advisory Council(SAAC)?"}
                            helper={[]}
                            options = {["Yes", "No"]}
                            required={true}
                            errors={errors.q21}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <TextInput
                            name={"q22"}
                            control={control}
                            question={"22. What is your Instagram username? (optional)"}
                            required={false}
                            errors={errors.q22}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <TextInput
                            name={"q23"}
                            control={control}
                            question={"23. What is your TikTok username? (optional)"}
                            required={false}
                            errors={errors.q23}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <TextInput
                            name={"q24"}
                            control={control}
                            question={"24. What is your Snapchat username? (optional)"}
                            required={false}
                            errors={errors.q24}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <TextInput
                            name={"q25"}
                            control={control}
                            question={"25. What is your YouTube username? (optional)"}
                            required={false}
                            errors={errors.q25}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <SingleSelect
                            name={"q26"}
                            control={control}
                            question={"By accepting these terms to participate in the ARISE powered by auntEDNA.ai:"}
                            helper={[
                                "1. I will allow my personal preference data to be used to build an algorithm helping me to access mentor & opportunities.",
                                "2. I am comfortable receiving text messages with recommendations from ARISE.",
                                "Consent to SMS Communication:",
                                "By providing your mobile phone number and checking the box, you agree that Edna.ai may send you periodic SMS messages containing important updates and information related to our mentorship program.",
                                "Your consent is not a condition of purchase or participation in our program. Message and data rates may apply.",
                                "If at any time you wish to withdraw your consent and stop receiving SMS messages, you can opt out by simply replying 'STOP' to any message we send. Once we receive your 'STOP' message, we will promptly remove your number from our SMS communication list and you will no longer receive SMS messages from us.",
                                "By checking this box, you confirm that you have read, understood and agreed to these terms.",
                                "3. The above terms and conditions are subject to change. A notification will be sent when that change occurs.",
                                "If you would like to decline, please send an email to tracey@athleda.org"
                            ]}
                            options = {["I accept"]}
                            required={true}
                            errors={errors.q26}/>
                    </ListItem>
                </List>
                <Button type='submit' className="m-form-button" variant="outlined" onClick={handleSubmit(getTopMentors, onError)}>Submit</Button>
                </Box>
            </form>
        </div>
    )
}

export default MenteeForm;